import { render, staticRenderFns } from "./LanguageAddDialog.vue?vue&type=template&id=2d064db5"
import script from "./LanguageAddDialog.vue?vue&type=script&lang=js"
export * from "./LanguageAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports